/* eslint-disable import/prefer-default-export */

import {
  GET_DISCUSSION,
  GET_DISCUSSION_SUCCESS,
  GET_DISCUSSIONS_FAIL,
  RESET_DISCUSSION,
} from '../constants';

export function resetDiscussion() {
  return {
    type: RESET_DISCUSSION,
  };
}

export function getDiscussion(id) {
  return {
    types: [GET_DISCUSSION, GET_DISCUSSION_SUCCESS, GET_DISCUSSIONS_FAIL],
    promise: fetch =>
      fetch(`/api/discussions/${id}`, {
        method: 'GET',
      }),
  };
}
